import angular from 'angular'
import {
    department
} from 'redevConfig'

const add = (department && department.add) || ''
const list = (department && department.list) || ''

const departmentListCtrl = list ? require(`redevelopment/system/department/${list.controllerName}`) : require('./departmentListCtrl')
const editDepartmentCtrl = add ? require(`redevelopment/system/department/${add.controllerName}`) : require('./editDepartmentCtrl')

const departmentListPage = list ? require(`redevelopment/system/department/${list.templateName}`) : require('./views/departmentList.html')
const editDepartmentPage = add ? require(`redevelopment/system/department/${add.templateName}`) : require('./views/editDepartment.html')

function config($stateProvider) {
    $stateProvider
        .state('system.permission.department', {
            url: '/department',
            template: '<div ui-view></div>',
            title: '部门管理',
            abstract: true,
            default: 'system.permission.department.list',
        })
        .state('system.permission.department.list', {
            url: '/list',
            controller: 'departmentListCtrl',
            template: departmentListPage,
        })
        .state('system.permission.department.add', {
            url: '/add/:orgId',
            controller: 'editDepartmentCtrl',
            template: editDepartmentPage,
            title: '新增',
        })
        .state('system.permission.department.edit', {
            url: '/edit/:departmentId',
            controller: 'editDepartmentCtrl',
            template: editDepartmentPage,
            title: '编辑',
        })
}
export default angular
    .module('system.permission.department', [])
    .config(['$stateProvider', config])
    .controller('departmentListCtrl', departmentListCtrl.default)
    .controller('editDepartmentCtrl', editDepartmentCtrl.default)
    .name


// WEBPACK FOOTER //
// ./src/app/system/permission/department/index.js